import React from 'react'
import Layout from 'components/layout'
import { Helmet } from 'react-helmet'
import HeroGradient from 'components/hero-image/hero-image-gradient'
import Promos from 'components/promos'
import Floater from 'components/floating-grid'
import { graphql } from 'gatsby'
import Content from 'components/category/content'

const items = [
  {
    link: '/stihl/hand-tools/battery-hand-tools/',
    imageId: 'batteryHandToolsImage',
    name: 'Battery Hand Tools',
    alt: 'STIHL Battery Hand Tools',
  },
]

const HandToolsPage = ({ data }) => {
  const { allHutsonPromotion, heroImage } = data
  const promos = []
  if (allHutsonPromotion) {
    allHutsonPromotion.nodes.forEach(node => promos.push(node))
  }
  const floaterItems = items.map(item => {
    item.image = data[item.imageId]
    return item
  })
  return (
    <Layout>
      <Helmet>
        <title>STIHL Hand Tools | Hutson Inc</title>
        <meta
          name='description'
          content='Precise work calls for precision tools. STIHL hand tools give you complete control. Get the quality and durability you expect from STIHL in the palm of your hand.'
        />
        <script type='application/ld+json'>
          {JSON.stringify({
            '@context': 'http://schema.org',
            '@type': 'BreadcrumbList',
            'itemListElement': [
              {
                '@type': 'ListItem',
                'position': 1,
                'name': 'Hutson Inc',
                'item': 'https://www.hutsoninc.com/',
              },
              {
                '@type': 'ListItem',
                'position': 2,
                'name': 'STIHL',
                'item': 'https://www.hutsoninc.com/stihl/',
              },
              {
                '@type': 'ListItem',
                'position': 3,
                'name': 'Hand Tools',
                'item': 'https://www.hutsoninc.com/stihl/hand-tools/',
              },
            ],
          })}
        </script>
      </Helmet>

      <HeroGradient image={heroImage} heading='STIHL Hand Tools' />

      <Content>
        <Floater items={floaterItems} />

        <Promos data={promos} type='STIHL Hand Tool' />
      </Content>
    </Layout>
  )
}

export const pageQuery = graphql`
  query handToolsStihlQuery($category: String = "hand-tools") {
    allHutsonPromotion(
      filter: {
        categoryList: { elemMatch: { category: { eq: $category }, type: { eq: "stihl" } } }
      }
      sort: { fields: [endDate], order: DESC }
      limit: 3
    ) {
      nodes {
        ...HutsonPromo
      }
    }
    heroImage: file(relativePath: { eq: "stihl/hand-tools/hand-tools-bg.jpg" }) {
      ...FullWidthImage
    }
    batteryHandToolsImage: file(relativePath: { eq: "stihl/hand-tools/battery-hand-tools.jpg" }) {
      ...FloatingGridImage
    }
  }
`

export default HandToolsPage
